import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { auth, db } from "../../firebase";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  getDoc,
  doc,
  limit
} from "firebase/firestore";
import Menu from "../../panel/Menu";

import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

export default function Userlogs() {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
  });

  const [userData, setUserData] = useState(null);
  const [loadincount, setLoadincount] = useState(true);

  const [logs, setLogs] = useState([]);
  const [allLogs, setAllLogs] = useState([]);
  const [searchText, setSearchText] = useState("");

  /* 🔐 AUTH */
  useEffect(() => {
    const unsub = auth.onAuthStateChanged(user => {
      setUserData(user);
    });
    return () => unsub();
  }, []);

  /* 📌 FETCH USER + LOGS */
  useEffect(() => {
    if (!userData || !loadincount) return;

    const fetchUser = async () => {
      try {
        const docSnap = await getDoc(doc(db, "users", userData.uid));
        if (docSnap.exists()) {
          fetchLogs();
          setLoadincount(false);
        }
      } catch (err) {
        Toast.fire({ icon: "error", title: err.message });
      }
    };

    fetchUser();
  }, [userData]);

  /* 📊 FETCH LOGS (REALTIME) */
  const fetchLogs = async () => {
    try {
      const q = query(
        collection(db, "userlogs"),
        orderBy("createdAt", "desc"),
        limit(500)
      );

      onSnapshot(q, snap => {
        const data = snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setLogs(data);
        setAllLogs(data);
      });
    } catch (err) {
      Toast.fire({ icon: "error", title: err.message });
    }
  };

  /* 🔍 SEARCH */
  useEffect(() => {
    if (!searchText) {
      setLogs(allLogs);
    } else {
      const filtered = allLogs.filter(item =>
        item.username?.toUpperCase().includes(searchText.toUpperCase())
      );
      setLogs(filtered);
    }
  }, [searchText, allLogs]);

  return (
    <Box display="flex" minHeight="100vh" bgcolor="#f4f6f8">
      <Menu />

      <Box className="content-wrapper" flex={1} p={3}>
        <Typography
          variant="h6"
          fontWeight={700}
          textTransform="uppercase"
          textAlign="right"
          mb={2}
        >
          || User Logs ||
        </Typography>

        <Card>
          <CardContent>
            <Box mb={2} maxWidth={300}>
              <TextField
                type="search"
                label="Search User"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                fullWidth
                size="small"
              />
            </Box>

            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell width={80}>Sr No</TableCell>
                    <TableCell>User Name</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Customer Name</TableCell>
                    <TableCell>Customer Mobile</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {logs.map((item, index) => (
                    <TableRow key={item.id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.username}</TableCell>
                      <TableCell>{item.type}</TableCell>
                      <TableCell>{item.customers?.custname}</TableCell>
                      <TableCell>{item.customers?.mobile}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          color="primary"
                          component="a"
                          href={`view-details/${item.bookingid}`}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}

                  {!logs.length && (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No logs found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
